import { 
  Component, 
  Input, 
  Output, 
  EventEmitter,
  ViewChild
} from '@angular/core';
import { ListBoxComponent } from 'source/app/controls/components/boxes/list-box/list-box-component';

@Component({
  templateUrl: './menu.html'  
})
export class MenuComponent { 

    constructor() { }

    public ItemsSource;

    @Input() IsDropDownOpen: boolean;
    @Output() IsDropDownOpenChange: EventEmitter<boolean> = new EventEmitter();
    @Input() IsMenuDropDownOpen: boolean;
    @Input() IsUserDropDownOpen: boolean;
    @Input() IsVersionDropDownOpen: boolean;
    @ViewChild(ListBoxComponent) listBox: ListBoxComponent;
    DateTimeNow:string;

    private isAlertsDropDownOpen: boolean;
    @Input() get IsAlertsDropDownOpen() {
      return this.isAlertsDropDownOpen;
    }
  
    set IsAlertsDropDownOpen(value: boolean) {
      this.isAlertsDropDownOpen = value;
    }

    @Input() State: string = "Home";

    OnSelectedItemChange($event) {
      this.IsAlertsDropDownOpen = false;
  }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/menu/menu-component.ts